import PublicAppointmentPage from "@/components/booking/public/PublicAppointmentPage";

export default function PublicAppointmentReceiptPage() {
  return <PublicAppointmentPage variant="receipt" />;
}
